var map = {
	"./05_run.png": 64513,
	"./23.png": 96930,
	"./CVX.png": 39481,
	"./FOCUS.png": 81187,
	"./UNCLE.png": 95089,
	"./audit.png": 38206,
	"./back.png": 75178,
	"./ball1.png": 62280,
	"./ball2.png": 53896,
	"./ball3.png": 81005,
	"./claim1.png": 66235,
	"./claim2.png": 51166,
	"./comingsoon.png": 52737,
	"./community.png": 72773,
	"./convert.png": 58668,
	"./convert1.png": 63247,
	"./discord.png": 15889,
	"./dots.png": 35373,
	"./expand.png": 20816,
	"./focusmeta.png": 59653,
	"./footer.png": 71911,
	"./gamebg.png": 48157,
	"./header.png": 82365,
	"./howitwork.png": 49969,
	"./landingBg.png": 18072,
	"./landingBg2.png": 14257,
	"./landingBg3.png": 15009,
	"./landingBg4.png": 26385,
	"./landingBg5.png": 48927,
	"./landingBg6.png": 34822,
	"./leaderboard.png": 11416,
	"./logo.png": 15080,
	"./lpProvider.png": 83377,
	"./lpProvider1.png": 32796,
	"./pill.png": 43505,
	"./share1.png": 64328,
	"./sign1.png": 48469,
	"./sign2.png": 22263,
	"./stake.png": 3783,
	"./step.png": 73297,
	"./step1.png": 37994,
	"./step1_0.png": 66620,
	"./step1_1.png": 57513,
	"./step2.png": 29207,
	"./step2_0.png": 79889,
	"./step2_1.png": 89724,
	"./step3.png": 64912,
	"./step3_0.png": 28507,
	"./step3_1.png": 88683,
	"./step4.png": 32820,
	"./step4_0.png": 77352,
	"./step4_1.png": 8042,
	"./twitter.png": 61591,
	"./useApp.png": 66532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64548;